import { blogCategories } from "../../../mocks/blog";

interface CategoryFilterProps {
  active: string;
  onChange: (cat: string) => void;
  counts: Record<string, number>;
}

export default function CategoryFilter({ active, onChange, counts }: CategoryFilterProps) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      {blogCategories.map((cat) => {
        const isActive = active === cat;
        return (
          <button
            key={cat}
            onClick={() => onChange(cat)}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-display font-medium transition-all duration-200 cursor-pointer whitespace-nowrap border ${
              isActive
                ? "text-white border-brand-purple/60 bg-brand-purple/20"
                : "text-white/50 border-white/10 hover:border-white/25 hover:text-white/80"
            }`}
            style={isActive ? { background: "rgba(168,85,247,0.15)" } : { background: "rgba(255,255,255,0.03)" }}
          >
            {cat}
            <span className={`text-xs px-1.5 py-0.5 rounded-full font-body ${isActive ? "bg-brand-purple/30 text-white/80" : "bg-white/5 text-white/30"}`}>
              {counts[cat] ?? 0}
            </span>
          </button>
        );
      })}
    </div>
  );
}
